import moment from 'moment';

const region = 'GMT';
const dateTimeFormat = 'YYYY-M-D HH:mm:ss';

export const dateFormat = (str) => {
  let date = moment.tz(str, dateTimeFormat, region).format();
  return date;
};
